(ns frontend.view.grid.tasks-grid.subs
  (:require
   [re-frame.core :as rf :refer [reg-sub]]
   [frontend.db :as frontend-db]
   [frontend.utils :as fu]
   [frontend.view.grid.tasks-grid.db :as tasks-db]
   [frontend.state.current-session :as session]
   [common.entity :as entity]))

(reg-sub
 ::view-config-initialized?
 (fn [db _]
   (let [config (get-in db [:view-configuration :entity.type/task])]
     (boolean config))))

(reg-sub
 :entity-types
 (fn [db _]
   (:entity-types @tasks-db/tasks)))

(reg-sub
 ::tasks
 :<-
 [:entity-types]
 (fn [grouped-entities _]
   (let [tasks (:entity.type/task grouped-entities)]
     tasks)))


; Todo this is temporary way to store view config.
(reg-sub
 ::view-configuration
 (fn [db _]
   (get-in db [:view-configuration :entity.type/task])))

(reg-sub
 ::kanban-config
 :<-
 [::view-configuration]
 (fn [view-configuration]
   (:card-view view-configuration)))

(reg-sub
 ::task-filters
 :<-
 [::view-configuration]
 (fn [view-configuration]
   (:filters view-configuration)))

(reg-sub
 ::tasks-kanban
 :<-
 [::view-configuration]
 :<-
 [::tasks]
 (fn [[view-configuration tasks] [_ {:keys [tasks-override]}]]
   (let [; Todo delete this once real architecture is implemented!!!

         config (:card-view view-configuration)
         tasks tasks-override

         view-settings (:view-settings config)

         group-by-attribute (-> view-settings
                                :grouping
                                :group-by)

         sort-by-key (-> view-settings
                         :sorting
                         :sort-by)
         sort-direction (-> view-settings
                            :sorting
                            :sort-direction)

         grouped-tasks (->> tasks
                            (group-by (fn [task]
                                        (let [value (get task group-by-attribute)]
                                          (if (= group-by-attribute :task/completed?)
                                            (boolean value) ; Uncompleted tasks can have false or nil as the value
                                            value))))
                            (into (sorted-map)))
         column-values (keys grouped-tasks)
         column-labels (->> column-values
                            (map-indexed (fn [index value]
                                           (condp = group-by-attribute
                                             :task/completed?
                                             (if value
                                               "Completed"
                                               "Pending")

                                             :task/due
                                             (if value
                                               (fu/display-date-timestamp value)
                                               "Not set")

                                             :common/created-on
                                             (if value
                                               (fu/display-date-timestamp value)
                                               "Not set")

                                             (let [entity (get @frontend-db/entities value)
                                                   display-string (entity/display-string entity)
                                                   value (nth column-values index)]
                                               (or display-string value "Not set"))))))

         column-contents (->> (vals grouped-tasks)
                              (mapv (fn [column-items]
                                      (if-not sort-by-key
                                        column-items
                                        (let [comp (if (= sort-direction :ascending)
                                                     <
                                                     >)
                                              sorted-items (->> column-items
                                                                (sort-by sort-by-key comp))]
                                          sorted-items)))))
         data {:column-values   column-values
               :column-labels   column-labels
               :column-contents column-contents}]

     data)))
